// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__10Fdy","title":"BackImages_title__14UxS","images":"BackImages_images__QWja8"};